import { Spinner } from 'flowbite-react';
import { useEffect } from 'react';
import Container from 'src/components/shared/Container';
import { API_ENDPOINT, LINKEDIN_CLIENT_ID } from 'src/config/env.config';

const LinkedinOpenAuth = () => {
	const token = localStorage.getItem('linkedinShareToken');

	useEffect(() => {
		if (!token)
			window.open(
				`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${API_ENDPOINT}/convocation/callback&state=foobar&scope=r_liteprofile%20r_emailaddress%20w_member_social%20openid%20profile%20email`,
				// `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=https://3775-103-105-226-54.ngrok-free.app/convocation/callback&state=foobar&scope=r_liteprofile%20r_emailaddress%20w_member_social%20openid%20profile%20email`,
				'_self',
			);
		// else window.open(`https://3775-103-105-226-54.ngrok-free.app/convocation/post-on-linkedin?token=${token}`, '_self');
		else window.open(`${API_ENDPOINT}/convocation/post-on-linkedin?token=${token}`, '_self');
	}, [token]);

	return (
		<Container className="w-[92%] max-w-[1366px] sm:w-[96%]">
			<div className="mb-[372px] mt-[220px] sm:mb-[100px] sm:mt-[100px]">
				<div className="flex justify-center text-[24px] font-[500] text-[#FAFAFC]">
					<div className="max-w-[487px] text-center sm:max-w-[100%]">
						<Spinner />
					</div>
				</div>

				<div className="mt-2 flex justify-center text-[16px] font-[400] text-[#C7C9D9]">
					<div className="max-w-[487px] text-center sm:max-w-[100%]">Sharing your post on linkedin...</div>
				</div>
			</div>
		</Container>
	);
};

export default LinkedinOpenAuth;
